import { c } from 'react-compiler-runtime';
import { forwardRef } from 'react';
import { getResponsiveAttributes } from '../internal/utils/getResponsiveAttributes.js';
import classes from './Stack.module.css.js';
import { clsx } from 'clsx';
import { jsx } from 'react/jsx-runtime';

const Stack = /*#__PURE__*/forwardRef((t0, forwardedRef) => {
  const $ = c(37);
  let children;
  let className;
  let gap;
  let rest;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[0] !== t0) {
    ({
      as: t1,
      children,
      align: t2,
      direction: t3,
      gap,
      justify: t4,
      padding: t5,
      wrap: t6,
      className,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = gap;
    $[4] = rest;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    children = $[1];
    className = $[2];
    gap = $[3];
    rest = $[4];
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
    t6 = $[10];
  }
  const Component = t1 === undefined ? "div" : t1;
  const align = t2 === undefined ? "stretch" : t2;
  const direction = t3 === undefined ? "vertical" : t3;
  const justify = t4 === undefined ? "start" : t4;
  const padding = t5 === undefined ? "none" : t5;
  const wrap = t6 === undefined ? "nowrap" : t6;
  let t7;
  if ($[11] !== className) {
    t7 = clsx(className, classes.Stack);
    $[11] = className;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== gap) {
    t8 = getResponsiveAttributes("gap", gap);
    $[13] = gap;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== direction) {
    t9 = getResponsiveAttributes("direction", direction);
    $[15] = direction;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== align) {
    t10 = getResponsiveAttributes("align", align);
    $[17] = align;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== wrap) {
    t11 = getResponsiveAttributes("wrap", wrap);
    $[19] = wrap;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== justify) {
    t12 = getResponsiveAttributes("justify", justify);
    $[21] = justify;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== padding) {
    t13 = getResponsiveAttributes("padding", padding);
    $[23] = padding;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== Component || $[26] !== children || $[27] !== forwardedRef || $[28] !== rest || $[29] !== t10 || $[30] !== t11 || $[31] !== t12 || $[32] !== t13 || $[33] !== t7 || $[34] !== t8 || $[35] !== t9) {
    t14 = /*#__PURE__*/jsx(Component, {
      ref: forwardedRef,
      ...rest,
      className: t7,
      ...t8,
      ...t9,
      ...t10,
      ...t11,
      ...t12,
      ...t13,
      children: children
    });
    $[25] = Component;
    $[26] = children;
    $[27] = forwardedRef;
    $[28] = rest;
    $[29] = t10;
    $[30] = t11;
    $[31] = t12;
    $[32] = t13;
    $[33] = t7;
    $[34] = t8;
    $[35] = t9;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  return t14;
});
const StackItem = /*#__PURE__*/forwardRef((t0, forwardedRef) => {
  const $ = c(21);
  let children;
  let className;
  let grow;
  let rest;
  let shrink;
  let t1;
  if ($[0] !== t0) {
    ({
      as: t1,
      children,
      grow,
      shrink,
      className,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = grow;
    $[4] = rest;
    $[5] = shrink;
    $[6] = t1;
  } else {
    children = $[1];
    className = $[2];
    grow = $[3];
    rest = $[4];
    shrink = $[5];
    t1 = $[6];
  }
  const Component = t1 === undefined ? "div" : t1;
  let t2;
  if ($[7] !== className) {
    t2 = clsx(className, classes.StackItem);
    $[7] = className;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== grow) {
    t3 = getResponsiveAttributes("grow", grow);
    $[9] = grow;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== shrink) {
    t4 = getResponsiveAttributes("shrink", shrink);
    $[11] = shrink;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== Component || $[14] !== children || $[15] !== forwardedRef || $[16] !== rest || $[17] !== t2 || $[18] !== t3 || $[19] !== t4) {
    t5 = /*#__PURE__*/jsx(Component, {
      ref: forwardedRef,
      ...rest,
      className: t2,
      ...t3,
      ...t4,
      children: children
    });
    $[13] = Component;
    $[14] = children;
    $[15] = forwardedRef;
    $[16] = rest;
    $[17] = t2;
    $[18] = t3;
    $[19] = t4;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  return t5;
});

export { Stack, StackItem };
